import camelCase from 'lodash/camelCase';
import { toSentenceCase } from 'utils';

import { notNullOrUndefined, onlyNumeric, required } from './utils';

import {
  BRIVO_SITE_ID_SELECT,
  CHECKBOX,
  DATE_TIME_PICKER,
  REACT_SELECT_INPUT,
  STYLED_PASSWORD,
  STYLED_TEXT,
} from './fieldTypes';

export const getFormInitialValues = (
  accountSchema,
  externalAccount,
  isUpdate,
) => {
  if (!accountSchema) return {};
  if (isUpdate) {
    return externalAccount;
  }
  const initialValues = {};
  accountSchema?.fields
    ?.filter((field) => !field?.readOnly)
    ?.forEach((field) => {
      const keyName = camelCase(field?.name);
      const value = field.default;
      initialValues[keyName] = value;
    });

  return initialValues;
};

const formatOptions = (options) =>
  Object.keys(options)?.map((key) => ({ label: options?.[key], value: key }));

const formatBrivoSiteIdOptions = (options) =>
  options.map((option) => ({
    label: `${option?.name} / ${option?.id}`,
    value: option?.id,
  }));

export const generateFormFieldsFromSchema = (
  accountSchema,
  isUpdate,
  // brivo site id workaround
  brivoSiteIdOptions = [],
  selectedBrivoAccount,
) => {
  const accountFields = accountSchema?.fields
    ?.filter(({ readOnly }) => isUpdate || !readOnly)
    ?.map(({ type, label, name, allowNull, choices, readOnly }) => {
      const field = {
        label: label || toSentenceCase(name),
        keyName: camelCase(name),
        validate: allowNull ? [] : [required],
        fieldType: STYLED_TEXT,
        disabled: readOnly,
      };

      switch (type) {
        case 'choice':
          field.fieldType = REACT_SELECT_INPUT;
          field.options = formatOptions(choices);
          field.validate = [];
          field.isClearable = allowNull;
          break;
        case 'bool':
          field.fieldType = CHECKBOX;
          field.validate = [notNullOrUndefined];
          break;
        case 'credentials':
          field.fieldType = STYLED_PASSWORD;
          break;
        case 'integer':
          field.validate.push(onlyNumeric);
          break;
        case 'datetime':
          field.fieldType = DATE_TIME_PICKER;
          break;
        case 'brivo_site_id_select':
          field.fieldType = BRIVO_SITE_ID_SELECT;
          field.account = selectedBrivoAccount;
          field.options = formatBrivoSiteIdOptions(brivoSiteIdOptions);
          field.validate = [];
          field.isClearable = allowNull;
          break;
        case 'string':
        default:
          break;
      }

      return field;
    });

  return accountFields || [];
};
